/**
 * signalr
 *
 * https://docs.microsoft.com/zh-cn/aspnet/signalr/overview/guide-to-the-api/hubs-api-guide-javascript-client
 *
 * 使用方式：
 * 1、App.vue 引入该文件
 * 2、在 mounted 调用 start 方法
 */
import Vue from 'vue'
import { mapGetters } from 'vuex'
// import PushMessageCard from '@/components/PushMessageCard'
import Config from '@/utils/Config'
import bus from '@/utils/bus'
// import i18n from "@/VueI18n/Index";
// import store from "@/store/Index";
import jQuery from 'jquery'
import store from '@/store/index'
window.jQuery = jQuery
window.$ = jQuery

// /**
//  * 用于监听数据的组件
//  */
// const WatchUsernameComponent = Vue.extend({
//   data() {
//     return {};
//   },

//   props: {
//     handle: Function,
//   },

//   watch: {
//     username: function(newValue, oldValue) {
//       if (typeof this.handle === "function") {
//         this.handle.call(null, newValue, oldValue);
//       }
//     },
//   },

//   computed: {
//     ...mapGetters(["isLogined", "username"]),
//   },
// });

class SignalRClient {
    constructor(type) {
        // console.log('1', this.type)
        this.type = type
        this.chat = null
        this.cardVNode = null
        this.init = false
    }

    start() {
        if (this.init) return
        // this.watchNotify = new WatchUsernameComponent({ store, i18n });
        // this.watchNotify.handle = (newValue, oldValue) =>
        //   this.onUsernameChanged(newValue, oldValue);
        this.init = true
        this.loadJavaScript('/jquery.signalR-2.1.2.min.js')
            .then(() => this.loadJavaScript(`${Config.SERVER_URL}/signalr/hub/hubs`))
            .then(() => this.buildConnection())
            .catch(error => {
                this.init = false
                console.log(error)
            })
    }
    stop() {
        // this.chat.server.exitHub()
        $.connection.hub.stop()
    }

    //   onUsernameChanged(newValue, oldValue) {
    //     $.connection.hub.qs = { loginName: newValue };
    //     if (newValue) {
    //       $.connection.hub.start().then(() => {
    //         this.chat.server.ShowBuyMsg(/*this.watchNotify.username*/);
    //       });
    //     } else {
    //       this.chat.server.exitHub(oldValue);
    //       $.connection.hub.stop();
    //     }
    //   }

    buildConnection() {
        // 指定signalR服务器
        console.log('qs', this.type)
        $.connection.hub.url = Config.SERVER_URL + '/signalr'
        $.connection.hub.qs = { pushType: this.type }
        // 连接服务端集线器
        this.chat = $.connection.SelectNumberBuyHub
        // 定义客户端方法，此客户端方法必须与服务端集线器中的方法名称、参数均一致。
        // 实际上是服务端调用了前端的js方法（订阅）
        this.chat.client.showMessage = response => {
            if (typeof response === 'string') response = JSON.parse(response)
            console.log('====>', response)
            if (response.pushType === 0) {
                store.commit('save', response)
            } else {
                store.commit('saveMillion', response)
            }
            // bus.$emit("message", response);
            // if (!this.cardVNode) {
            //     // 创建div容器
            //     const div = document.createElement('div')
            //     div.setAttribute('style', 'z-index: 99999;')
            //     document.body.appendChild(div)
            //     // 创建消息推送的显示弹窗
            //     const PushMessageCard_SignalR = Vue.extend(Object.assign(PushMessageCard, { name: 'PushMessageCard_SignalR' }))
            //     this.cardVNode = new PushMessageCard_SignalR({ i18n, store }).$mount(div)
            // }
            // // 更新消息数据
            // this.cardVNode.showMessages(response.data)
        }
        /**
         * signalR 提供了以下生命周期的回调：
         * - starting: 在任何数据发送之前执行
         * - received: 当任何数据通过连接获取到的时候执行。可以得到数据
         * - connectionSlow: 当客户端检测到缓慢或者不流畅的连接的时候执行
         * - reconnecting: 当潜在的协议重新开始连接的时候执行
         * - reconnected: 当潜在的协议以及重新建立连接的时候执行
         * - stateChanged: 当连接的状态发生改变的时候执行
         * - disconnected: 当连接中断以后执行
         */
        // $.connection.hub.starting(() => console.log('==> signalr starting'))
        // $.connection.hub.received(() => console.log('==> signalr received'))
        // $.connection.hub.connectionSlow(() => console.log('==> signalr connectionSlow'))
        // $.connection.hub.reconnecting(() => console.log('==> signalr reconnecting'))
        // $.connection.hub.reconnected(() => console.log('==> signalr reconnected'))
        // $.connection.hub.stateChanged(() => console.log('==> signalr stateChanged'))
        // $.connection.hub.disconnected(() => console.log('==> signalr disconnected'))
        // 处理错误
        $.connection.hub.error(error => console.log('signalr error:', error))
        // 连接服务端
        // if (this.watchNotify.username) {
        $.connection.hub.start().then(() => {
            this.chat.server.showBuyMsg(/*this.watchNotify.username*/)
        })
        // }
    }

    loadJavaScript(url) {
        return new Promise((resolve, reject) => {
            const ascript = document.createElement('script')
            ascript.addEventListener('load', event => resolve(), false)
            ascript.setAttribute('type', 'text/javascript')
            ascript.setAttribute('src', url)
            document.head.appendChild(ascript)
        })
    }
}

const client = new SignalRClient()
export default SignalRClient
